/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetUsersProfileWebimQueryResponse, GetUsersProfileWebim400 } from "../entities/GetUsersProfileWebim";

function getGetUsersProfileWebimUrl() {
  const res = { method: 'GET', url: `/users/profile/webim` as const }  
  return res
}

/**
 * @description Получение авторизованного посетителя для Webim
 * @summary Get Webim Visitor
 * {@link /users/profile/webim}
 */
export async function getUsersProfileWebim(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetUsersProfileWebimQueryResponse, ResponseErrorConfig<GetUsersProfileWebim400>, unknown>({ method : "GET", url : getGetUsersProfileWebimUrl().url.toString(), ... requestConfig })  
  return res.data
}